import React from 'react';

import { cache } from 'tm3-core/cache';
import type { IsProduct } from 'tm3-core/enums/product-enum';

interface IProps extends React.PropsWithChildren {
  product?: IsProduct;
  products?: IsProduct[];
}

export const withHideFrom = <T extends U, U extends object>(
  Comp: React.ComponentType<U>,
  products?: IsProduct[]
) => {
  const WrappedComponent: React.FC<T> = (props: T) => {
    return (
      <HideFrom products={products}>
        <Comp {...props} />
      </HideFrom>
    );
  };

  WrappedComponent.displayName = 'WithHideFrom';

  return WrappedComponent;
};

const HideFrom: React.FC<IProps> = React.memo(({ product, products, children }) => {
  if (products?.some((p) => cache.checkLicence(p))) return null;
  if (product != null && cache.checkLicence(product)) return null;
  return children;
});

HideFrom.displayName = 'HideFrom';

export default HideFrom;
